import React, { useState } from 'react';
import styles from './adminStyles.module.css';

function ProductTable({
  products,
  starredIds,
  onToggleStar,
  onEdit,
  onDelete,
}) {
  const maxStars = 8;
  const starCount = starredIds.length;
  const [previewImage, setPreviewImage] = useState(null);

  if (products.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>אין מוצרים בדף , תלחצי על הוספת מוצר כדי להתחיל.</p>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.productTable}>
        <thead>
          <tr>
            <th>⭐ מועדפים</th>
            <th>תמונה</th>
            <th>שם</th>
            <th>תיאור</th>
            <th>מחיר</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => {
            const isStarred = starredIds.includes(product._id);
            const canStar = starCount < maxStars;

            return (
              <tr
                key={product._id}
                className={isStarred ? styles.starredRow : ''}
              >
                <td>
                  <button
                    className={`${styles.starButton} ${
                      isStarred
                        ? styles.starActive
                        : !canStar
                        ? styles.starDisabled
                        : ''
                    }`}
                    onClick={() => {
                      if (isStarred || canStar) {
                        onToggleStar(product._id);
                      }
                    }}
                    title={
                      isStarred
                        ? 'Remove from Home'
                        : canStar
                        ? 'Add to Home'
                        : 'Max 8 stars reached'
                    }
                    disabled={!isStarred && !canStar}
                  >
                    {isStarred ? '⭐' : '☆'}
                  </button>
                  {isStarred && (
                    <span className={styles.homeBadge}>מופיע בדף בית</span>
                  )}
                </td>
                <td>
                  <img
                    className={styles.productImage}
                    src={product.image}
                    alt={product.name}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setPreviewImage(product.image)}
                    onError={(e) => {
                      e.target.src =
                        'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50"><rect fill="%23ddd" width="50" height="50"/><text fill="%23999" x="8" y="30" font-size="10">No img</text></svg>';
                    }}
                  />
                </td>
                <td>
                  <span className={styles.productName}>{product.name}</span>
                </td>
                <td>
                  <span style={{ fontSize: '13px', color: '#888' }}>
                    {product.description
                      ? product.description.length > 60
                        ? product.description.substring(0, 60) + '...'
                        : product.description
                      : '—'}
                  </span>
                </td>
                <td>
                  <span className={styles.productPrice}>₪{product.price}</span>
                </td>
                <td>
                  <button
                    className={styles.actionButton}
                    onClick={() => onEdit(product)}
                  >
                    ✏️ עריכה
                  </button>
                  <button
                    className={`${styles.actionButton} ${styles.deleteButton}`}
                    onClick={() => onDelete(product)}
                  >
                    🗑️ מחיקה
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Image Preview Lightbox */}
      {previewImage && (
        <div
          className={styles.modalOverlay}
          onClick={() => setPreviewImage(null)}
        >
          <img
            src={previewImage}
            alt="Preview"
            style={{
              maxWidth: '90vw',
              maxHeight: '85vh',
              borderRadius: '12px',
              boxShadow: '0 8px 40px rgba(0,0,0,0.3)',
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

export default ProductTable;
